<template>
    <C1Button
        type="button"
        variant="secondary"
        :size="size"
        :disabled="isSaved"
        @click.stop.prevent="click()"
        block
    >
        <slot />
    </C1Button>
</template>

<script>
    import C1Button from '@/components/C1Components/C1Button';

    export default {
        name: 'SaveSearchBtn',

        components: {
            C1Button,
        },

        props: {
            isSaved: {
                type: Boolean,
                default: false,
            },
            size: {
                type: String,
                default: 'md',
                validator: value => ['sm', 'lg', 'md', 'xl'].includes(value),
            },
        },

        data() {
            return {};
        },

        computed: {
            classList() {
                return [
                    'af-save-search-btn',
                    this.getIsSavedClass,
                ];
            },

            getIsSavedClass() {
                return this.isSaved ? 'af-is-saved' : '';
            },
        },

        methods: {
            click() {
                this.$emit('click');
            },
        },
    };
</script>
